import { FeedItemDto } from "models/ApiModels";
import HtmlUtils from "lib/HtmlUtils";
import { PublicationType } from "models/ApiEnums";

export enum FeedMessageKeys {
    TRY_ADD_PUBLICATION = '@@FeedMessageKeys/TRY_ADD_PUBLICATION',
    TRY_UPDATE_PUBLICATION = '@@FeedMessageKeys/TRY_UPDATE_PUBLICATION',
    TRY_DELETE_PUBLICATION = '@@FeedMessageKeys/TRY_DELETE_PUBLICATION',
    TRY_FEED_RESET = '@@FeedMessageKeys/TRY_FEED_RESET',
}

export interface MessageTryAddFeedData {
    readonly type: FeedMessageKeys.TRY_ADD_PUBLICATION;
    readonly item: { publicationId: string, publicationType: PublicationType }
}


export interface MessageTryUpdateFeedData {
    readonly type: FeedMessageKeys.TRY_UPDATE_PUBLICATION;
    readonly item: Partial<FeedItemDto>
}

export interface MessageTryDeleteFeedData {
    readonly type: FeedMessageKeys.TRY_DELETE_PUBLICATION;
    readonly publicationId: string;
}

export interface MessageTryFeedReset{
    readonly type: FeedMessageKeys.TRY_FEED_RESET;
}

export type FeedMessageTypes =
    | MessageTryAddFeedData
    | MessageTryUpdateFeedData
    | MessageTryDeleteFeedData
    | MessageTryFeedReset;


export class FeedPostWindowMessages {
    private location: string;

    constructor(private window: Window) {
        this.location = HtmlUtils.getFullLocation();
    }

    tryUpdateFeedData(item: DeepPartial<FeedItemDto>) {
        if (this.window)
            this.window.postMessage({ type: FeedMessageKeys.TRY_UPDATE_PUBLICATION, item }, this.location)
    }

    tryDeleteFeedData(publicationId: string) {
        if (this.window)
            this.window.postMessage({ type: FeedMessageKeys.TRY_DELETE_PUBLICATION, publicationId }, this.location)
    }

    tryAddFeedData(publicationId: string, publicationType: PublicationType) {
        if (this.window)
            this.window.postMessage({ type: FeedMessageKeys.TRY_ADD_PUBLICATION, item: { publicationId, publicationType } }, this.location)
    }

    tryFeedReset() {
        if (this.window)
            this.window.postMessage({ type: FeedMessageKeys.TRY_FEED_RESET }, this.location)
    }
}
